import React, { createContext, useContext, useMemo, useCallback } from 'react';

import { useStateWithSessionStorage } from '../hooks/useStateWithSessionStorage';

const BillingPaymentContext = createContext({});

const defaultValues = {
  billingDetails: {},
  paymentDetails: {},
};
function BillingPaymentProvider({ children }) {
  const [billingDetails, setBillingDetails] = useStateWithSessionStorage(
    'billingDetails',
    defaultValues.billingDetails
  );
  const [paymentDetails, setPaymentDetails] = useStateWithSessionStorage(
    'paymentDetails',
    defaultValues.paymentDetails
  );

  const resetBillingDetails = useCallback(
    () => setBillingDetails(defaultValues.billingDetails),
    [setBillingDetails]
  );

  const resetPaymentDetails = useCallback(
    () => setPaymentDetails(defaultValues.paymentDetails),
    [setPaymentDetails]
  );

  const contextValue = useMemo(
    () => ({
      billingDetails,
      setBillingDetails,
      resetBillingDetails,
      paymentDetails,
      setPaymentDetails,
      resetPaymentDetails,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [billingDetails, paymentDetails]
  );

  return (
    <BillingPaymentContext.Provider value={contextValue}>
      {children}
    </BillingPaymentContext.Provider>
  );
}

function useBillingPayment() {
  const context = useContext(BillingPaymentContext);
  if (context === undefined) {
    throw new Error('usePlan must be used within a BillingPaymentContext');
  }

  return context;
}

export { BillingPaymentProvider, useBillingPayment };
